import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { UIRouterModule } from '@uirouter/angular';

import { MenuModule } from '@app/primeng-overrides/menu';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import { ToolbarModule } from 'primeng/toolbar';
import { GlobalModule } from '@app/_global/global.module';

@Component({
	selector: 'aucun-access',
	template: `
		<span class="text-color-danger font-bold">{{'abonnes.user_no_access_to_any_site' | translate}} </span>
	` 
})
export class AucunAccesComponent implements OnInit {
	ngOnInit(): void {
		
	}
}

@NgModule({
	imports: [
		CommonModule,
		GlobalModule,
		UIRouterModule,
		FormsModule,
		ToolbarModule,
		MenuModule,
		PanelModule,
		DividerModule,
	],
	exports: [AucunAccesComponent],
	declarations: [AucunAccesComponent]
})
export class AucunAccesModule { }
